import React, { type ReactNode } from 'react';

export function escapeRegExpForHighlight(text: string): string {
  return text.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

export function formatCellValueForSearch(cellValue: unknown): string {
  if (Array.isArray(cellValue)) {
    return cellValue
      .map((item: { name: string }) => item.name)
      .join(' ')
      .toUpperCase();
  }
  return String(cellValue).replace(/\s+/g, ' ').toUpperCase();
}

export function renderHeaderLabelContent(label: ReactNode): ReactNode {
  if (typeof label === 'string') return label;
  if (React.isValidElement(label)) return label;
  return null;
}

const TABLE_ROW_KEY_FIELDS = ['id', 'profile_id', 'user_id', 'rowKey', 'uuid'] as const;

export function getHeaderColumnReactKey(header: { id?: string }, index: number): string {
  const id = header.id != null ? String(header.id).trim() : '';
  return id !== '' ? id : `col-${index}`;
}

export function getTableRowReactKey(row: unknown, rowIndex: number): string | number {
  if (row && typeof row === 'object') {
    const record = row as Record<string, unknown>;
    for (const field of TABLE_ROW_KEY_FIELDS) {
      const v = record[field];
      if (v != null && v !== '') {
        return `${field}:${String(v)}:${rowIndex}`;
      }
    }
  }
  return `row-${rowIndex}`;
}
